import { ApiTimezone } from '@core/services/timezone/timezone.interfaces';

/**
 * Maps raw timezone API data into a sorted array of dropdown options.
 *
 * @param data - The raw timezone data array from the API.
 * @returns An array of objects containing label and value for dropdown.
 */
export function mapTimezonesForDropdown(data: ApiTimezone[]): { label: string; value: number }[] {
    return data
        .map((tz) => ({
            label: tz.timezoneName,
            value: tz.timezoneId,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
}
